/**
 * templates domain — /templates/compile + /templates/fill.
 *
 * GOTCHA (api-wiring §6.4): /templates/compile returns PascalCase shape —
 * we normalize to camelCase at the api-client layer so callers get
 * `{success, compiledPdfBase64, fieldCount, error}`.
 */

import type {
  RequestOptions,
  TemplateCompileByIdRequest,
  TemplateCompileRequest,
  TemplateCompileResponse,
  TemplateFillRequest,
  TemplateFillResponse,
} from '@retail-ops/shared-types';
import type { ApiHttpClient } from '../http.js';

export class TemplatesApi {
  public constructor(private readonly http: ApiHttpClient) {}

  public compile(
    req: TemplateCompileRequest,
    opts?: RequestOptions
  ): Promise<TemplateCompileResponse> {
    return this.http.post<TemplateCompileResponse>('/templates/compile', {
      ...opts,
      body: req,
      normalizePascalToCamel: true,
    });
  }

  /**
   * Compile by templateCode — Function loads the active
   * DisclosureTemplateVersions.ContentHtml from SQL. Removes the need for
   * the SPA to ship the HTML body per request once SignStep switches to
   * this endpoint (Wave 6).
   */
  public compileById(
    req: TemplateCompileByIdRequest,
    opts?: RequestOptions
  ): Promise<TemplateCompileResponse> {
    return this.http.post<TemplateCompileResponse>('/v3/templates/compile-by-id', {
      ...opts,
      body: req,
      normalizePascalToCamel: true,
    });
  }

  public fill(req: TemplateFillRequest, opts?: RequestOptions): Promise<TemplateFillResponse> {
    return this.http.post<TemplateFillResponse>('/templates/fill', { ...opts, body: req });
  }
}
